import { CustomTableData, TooltipInformation } from 'common'
import { MenuOptions } from './Dropdown' // <-- ajusta la ruta según tu estructura

export const CollateralTable = ({ useFetchInit }) => {
    const { FetchData, Actions } = useFetchInit

    const { fetchAllCollateral: { collateral } } = FetchData

    const columnConfig = [
        {
            headerName: "Info",
            maxWidth: 80,
            cellStyle: () => ({
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
            }),
            cellRenderer: (params) => {
                const { idcollateral, usuario_creo, fecha_creo, usuario_modifico, fecha_modifico } = params.data

                return (
                    <TooltipInformation
                        idregistro={idcollateral}   // ✅ antes: idvehicledeposit
                        usuario_creo={usuario_creo}
                        fecha_creo={fecha_creo}
                        usuario_modifico={usuario_modifico}
                        fecha_modifico={fecha_modifico}
                    />
                )
            }
        },
        {
            field: "idcredito",
            headerName: "CREDITO",
            maxWidth: 120,
            minWidth: 120,
            filter: true,
            cellRenderer: (params) => `CRED${params.value}`,
        },
        { field: "type_collateral", headerName: "TIPO DE GARANTIA", minWidth: 300, filter: true },
        { field: "title", headerName: "TITLE", minWidth: 500, filter: true },
        { field: "valor", headerName: "VALOR (Q)", minWidth: 200, filter: true },

        // ✅ OPCIONES -> DropDown con 2 botones y 2 menús
        {
            headerName: "OPCIONES",
            minWidth: 400,
            cellRenderer: (params) => {
                return (
                    <MenuOptions
                        params={params}
                        Actions={Actions}
                    />
                )
            }
        },
    ]

    return (
        <div className='content'>
            <CustomTableData
                rowConfig={collateral}
                columnConfig={columnConfig}
            />
        </div>
    )
}